(() => {
  const STORAGE_KEY = 'mg-geoip-choice';
  const dialog = document.getElementById('MgGeoip');
  const config = document.getElementById('MgGeoipMarkets');

  if (!dialog || !config || typeof dialog.showModal !== 'function') return;
  if (navigator.webdriver || /bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent)) return;

  const saveChoice = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
      return true;
    } catch {
      return false;
    }
  };

  try {
    if (localStorage.getItem(STORAGE_KEY)) return;
  } catch {
    return;
  }

  const parseLines = (text) =>
    (text || '')
      .split('\n')
      .map((line) => line.split(':').map((part) => part.trim()))
      .filter((parts) => parts.length === 2 && parts[0] && parts[1]);

  const settings = JSON.parse(config.textContent);
  const { current, countries } = settings;
  const rules = Object.entries(settings.rules).map(([market, codes]) => [
    market,
    (codes || '').toUpperCase().split(/[\s,]+/).filter(Boolean),
  ]);
  const languages = Object.fromEntries(
    parseLines(settings.languages).map(([code, language]) => [code.toUpperCase(), language])
  );
  const form = dialog.querySelector('form');

  const recommend = (detected) => {
    if (countries[detected]) return { market: countries[detected], country: detected };

    const rule = rules.find(([, codes]) => codes.includes(detected));
    if (!rule) return {};

    const [market, codes] = rule;
    return { market, country: [...codes, ...Object.keys(countries)].find((code) => countries[code] === market) };
  };

  const open = (country, language) => {
    if (!saveChoice('shown')) return;

    form.elements.country_code.value = country;
    if (language) {
      form.elements.language_code.value = language;
      form.elements.language_code.disabled = false;
    }
    form.addEventListener('submit', () => saveChoice('accepted'));
    dialog.addEventListener('cancel', () => saveChoice('dismissed'));
    dialog.querySelectorAll('[data-mg-geoip-dismiss]').forEach((button) => {
      button.addEventListener('click', () => {
        saveChoice('dismissed');
        dialog.close();
      });
    });

    dialog.showModal();
  };

  fetch('/browsing_context_suggestions.json?country%5Benabled%5D=true', { headers: { Accept: 'application/json' } })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const detected = data?.detected_values?.country?.handle;
      if (!detected) return;

      const { market, country } = recommend(detected);
      if (!country || market === current) return;
      if (document.querySelector('dialog[open]')) return;

      open(country, languages[detected]);
    })
    .catch(() => {});
})();
